import get from "lodash/get";
import * as EdgeType from "utils/EdgeType";

export default function checkEdge(oldProps, newProps, lookup, direction) {
  if (get(newProps, lookup) === get(oldProps, lookup)) return false;

  const isPositiveEdge = get(newProps, lookup) === true;

  if (direction === EdgeType.POSITIVE) {
    return isPositiveEdge;
  }
  return !isPositiveEdge;
}
